module.exports = __webpack_public_path__ + "static/media/secure-package.f27240ab.svg";